import Layout from "Components/Layout";
import React, { useState } from "react";
import Styles from "./style.module.css";
import { CommonNotificationadd } from "Services/ServiceRequest";
import Swal from "sweetalert2";
import Loader from "Components/Loader/subload/loader";
function Page() {
    const [Active, setActive] = useState("msg_english");
    const [error_msg, setErrormsg] = useState(null);
    const [loading, setLoading] = useState(false);
    const [body, setBody] = useState({
        msg_english: { title: "", message: "" },
        msg_french: { title: "", message: "" },
        msg_spanish: { title: "", message: "" },
    });
    const Buttons = [
        { label: "English", value: "msg_english" },
        { label: "French", value: "msg_french" },
        { label: "Spanish", value: "msg_spanish" },
    ];
    const ChangeHandler = (value, key) => {
        setBody((prev) => ({
            ...prev,
            [Active]: { ...prev[Active], [key]: value },
        }));
    };
    const validateForm = () => {
        // Check if any of the title fields are missing
        if (!body.msg_english.title) {
            return {
                Active: "msg_english",
                type: "title",
                message: "Title is required in English",
            };
        }
        // Check if any of the message fields are missing
        if (!body.msg_english.message) {
            return {
                Active: "msg_english",
                type: "message",
                message: "Message is required in English",
            };
        }
        if (!body.msg_french.title) {
            return {
                Active: "msg_french",
                type: "title",
                message: "Title is required in French",
            };
        }
        if (!body.msg_french.message) {
            return {
                Active: "msg_french",
                type: "message",
                message: "Message is required in French",
            };
        }
        if (!body.msg_spanish.title) {
            return {
                Active: "msg_spanish",
                type: "title",
                message: "Title is required in Spanish",
            };
        }

        if (!body.msg_spanish.message) {
            return {
                Active: "msg_spanish",
                type: "message",
                message: "Message is required in Spanish",
            };
        }

        // If all fields are valid, return null or an empty object
        return null;
    };
    const onSubmit = async (event) => {
        event.preventDefault();
        let Errors = validateForm();
        if (Errors) {
            setErrormsg(Errors);
            setActive(Errors?.Active);
            return;
        }
        try {
            setLoading(true);
            const response = await CommonNotificationadd(body);

            setLoading(false);
            setBody({
                msg_english: { title: "", message: "" },
                msg_french: { title: "", message: "" },
                msg_spanish: { title: "", message: "" },
            });
            setActive("msg_english");
            setErrormsg(null);
            if (response?.data?.Status === 1) {
                Swal.fire({
                    title: "Success",
                    text: "Notification Sent Successfully",
                    icon: "Success",
                });
            }
        } catch (err) {
            setLoading(false);
            console.log("err");
            Swal.fire({
                title: "Error",
                text: "Something went wrong please try again",
                icon: "error",
            });
        }
    };
    return (
        <Layout Active={"noti"}>
            {loading && <Loader />}
            <div className={`Main_container ${Styles["container"]}`}>
                <h3>Notification </h3>
                <div className="request_Tabs">
                    {Buttons.map((item) => (
                        <button
                            className={Active == item.value ? "Active-tab" : ""}
                            onClick={() => setActive(item.value)}>
                            {item?.label}
                        </button>
                    ))}
                </div>
                <form onSubmit={onSubmit}>
                    <div className={Styles["form_control"]}>
                        <label htmlFor="">Title</label>
                        <input
                            type="text"
                            value={body[Active].title}
                            onChange={(e) =>
                                ChangeHandler(e.target.value, "title")
                            }
                        />
                    </div>
                    {error_msg &&
                        error_msg.type == "title" &&
                        error_msg.Active == Active && (
                            <span style={{ color: "red" }}>
                                {error_msg?.message}
                            </span>
                        )}
                    <div className={Styles["form_control"]}>
                        <label htmlFor="">Message</label>
                        <textarea
                            type="text"
                            cols={4}
                            rows={7}
                            value={body[Active].message}
                            onChange={(e) =>
                                ChangeHandler(e.target.value, "message")
                            }
                        />
                    </div>
                    {error_msg &&
                        error_msg.type == "message" &&
                        error_msg.Active == Active && (
                            <span style={{ color: "red" }}>
                                {error_msg?.message}
                            </span>
                        )}
                    <input type="submit" />
                </form>
            </div>
        </Layout>
    );
}

export default Page;
